import { render, staticRenderFns } from "./NavTab.vue?vue&type=template&id=ed4d38b0&"
import script from "./NavTab.vue?vue&type=script&lang=js&"
export * from "./NavTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed4d38b0')) {
      api.createRecord('ed4d38b0', component.options)
    } else {
      api.reload('ed4d38b0', component.options)
    }
    module.hot.accept("./NavTab.vue?vue&type=template&id=ed4d38b0&", function () {
      api.rerender('ed4d38b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/library/NavTab.vue"
export default component.exports